import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Segment } from 'semantic-ui-react';
import _ from 'lodash';
import { compose } from 'recompose';

import hasRESTClient from '../../hocs/has-rest-client';
import CampaignEcommerceModal from '../campaign-ecommerce-modal';
import hasOrganisation from '../../hocs/has-organisation';

const btnStyle = { marginTop: '10px' };


class CampaignEcommerceSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  fetchCampaign = async () => {
    const { restClient, campaignId } = this.props;
    this.setState({ isLoading: true });
    const response = await restClient.get(`campaigns/${campaignId}`);
    const campaign = _.get(response, 'data.data.attributes', {});
    this.setState({
      campaign,
      isLoading: false,
    });
  }

  componentDidMount = () => {
    this.fetchCampaign();
  }

  onSubmit = values => {
    const { restClient, campaignId } = this.props;
    this.setState({ isSubmitting: true });
    const payload = {
      data: {
        attributes: {
          ecommerceSettings: values,
        },
      },
    };
    restClient.patch(`campaigns/${campaignId}`, payload)
      .then(r => {
        this.setState({ isSubmitting: false, patchError: r.data ? null : true });
        this.closeModal();
        this.fetchCampaign();
        return r.data;
      },
      ).catch(err => {
        this.setState({ isSubmitting: false, patchError: err });
      });
  }
  closeModal = () => {
    this.setState({ modalOpened: false });
  }

  openModal = () => {
    this.setState({ modalOpened: true });
  }

  render() {
    const {
      campaign,
      modalOpened,
      isSubmitting,
      patchError,
      isLoading,
    } = this.state;
    const { organisation } = this.props;

    const { shopifyAccessToken, shopifyShopUrl } = _.get(organisation, 'ecommerceSettings', {});
    const ecommerceSettings = { ..._.get(campaign, 'ecommerceSettings', {}), shopifyAccessToken, shopifyShopUrl };
    return (
      <Segment>
        {
          modalOpened &&
            <CampaignEcommerceModal
              onSubmit={this.onSubmit}
              onClose={this.closeModal}
              ecommerceSettings={ecommerceSettings}
              isSubmitting={isSubmitting}
              error={patchError}
            />
        }
        <h3>Shopfluence Settings</h3>
        <Divider hidden fitted />
        <Button
          loading={isLoading}
          disabled={isLoading}
          style={btnStyle}
          color="pink"
          icon="edit"
          fluid
          onClick={this.openModal}
          labelPosition="left"
          content="Edit shopfluence settings"
        />
      </Segment>
    );
  }
}

CampaignEcommerceSettings.propTypes = {
  restClient: PropTypes.func.isRequired,
  campaignId: PropTypes.string.isRequired,
};

export default compose(
  hasRESTClient,
  hasOrganisation,
)(CampaignEcommerceSettings);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-ecommerce-settings/index.js
 **/